import React, { useState } from 'react';
import { Scissors, Plus, Search } from 'lucide-react';
import useAssessmentManagementStore from '@/stores/AdminStore/AssessmentManagementStore';
import './CarveAssessment.css';

const CarveAssessment: React.FC = () => {
  const { carveAssessmentSources } = useAssessmentManagementStore();

  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="admin-assessment-carve-assessment">
      <div className="admin-assessment-carve-header">
        <div className="admin-assessment-carve-icon-wrapper">
          <Scissors size={48} />
        </div>
        <div className="admin-assessment-carve-title-section">
          <h3>Carve Assessment</h3>
          <p>Create customized assessments by selecting specific questions from existing assessments</p>
        </div>
      </div>

      <div className="admin-assessment-carve-content">
        <div className="admin-assessment-search-box">
          <Search size={18} />
          <input
            type="text"
            placeholder="Search existing assessments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="admin-assessment-assessment-source-list">
          {carveAssessmentSources?.map((assessment) => (
            <div key={assessment.id} className="admin-assessment-source-item">
              <div className="admin-assessment-source-info">
                <h4>{assessment.name}</h4>
                <span>{assessment.questions} questions available</span>
              </div>
              <button className="admin-assessment-select-btn">
                <Plus size={16} />
                Select Questions
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CarveAssessment;
